import React from "react";
import {
  CloudCheck,
  CloudSlash,
  CircleNotch,
} from "@phosphor-icons/react";

/**
 * Tiny pill at the top of the Vault screen indicating whether the vault is
 * local-only (anonymous), syncing, synced, or temporarily offline.
 */
export default function SyncStatusPill({ isSignedIn, status, onSignIn }) {
  if (!isSignedIn) {
    return (
      <button
        type="button"
        onClick={onSignIn}
        data-testid="vault-signin-pill"
        className="w-full mb-3 bg-orange-soft border border-orange/15 rounded-2xl px-4 py-2.5 flex items-center justify-between gap-3 hover:bg-orange-soft/80 transition-colors"
      >
        <div className="flex items-center gap-2 min-w-0">
          <CloudSlash size={18} weight="duotone" color="#E55B2C" />
          <div className="text-left">
            <div className="font-jakarta font-extrabold text-navy text-sm leading-tight">
              Local only
            </div>
            <div className="text-navy-soft text-[11px] font-jakarta font-medium leading-tight">
              Sign in to sync across devices
            </div>
          </div>
        </div>
        <span className="bg-orange text-white font-jakarta font-extrabold text-[11px] uppercase tracking-wider rounded-full px-3 py-1.5">
          Sign in
        </span>
      </button>
    );
  }
  const map = {
    syncing: { Icon: CircleNotch, color: "#2A6FD8", soft: "#EAF2FB", label: "Syncing…", spin: true },
    synced: { Icon: CloudCheck, color: "#2E7D5A", soft: "#DCEFE3", label: "Synced to your account" },
    offline: { Icon: CloudSlash, color: "#E55B2C", soft: "#FDE6D8", label: "Offline — will sync when reconnected" },
    idle: { Icon: CloudCheck, color: "#2E7D5A", soft: "#DCEFE3", label: "Synced to your account" },
  };
  const m = map[status] || map.idle;
  return (
    <div
      data-testid="vault-sync-pill"
      className="w-full mb-3 rounded-2xl px-4 py-2 flex items-center gap-2"
      style={{ backgroundColor: m.soft }}
    >
      <m.Icon size={16} weight="duotone" color={m.color} className={m.spin ? "animate-spin" : ""} />
      <span className="font-jakarta font-bold text-sm" style={{ color: m.color }}>
        {m.label}
      </span>
    </div>
  );
}
